import React, { useEffect, useState } from "react";
import { getRequest } from "utils/request";
// @ts-ignore
import Select from "react-select";
import { translate } from "../../../translate/i18n";

type ApplyShortcutProps = {
  selectedCompany: {
    id: string | number;
  };
  blockTicket: boolean;
  handleInput: (arg: any) => void;
  disableLoading: () => void;
  selectTicketId: string | number;
};
export function ApplyShortcut(props: ApplyShortcutProps): JSX.Element {
  const {
    selectedCompany,
    blockTicket,
    handleInput,
    disableLoading,
    selectTicketId,
  } = props;
  const [listshortcut, setListShortcut] = useState([]);
  const [selectedshortcut, setSelectedShortcut] = useState<Record<string, any>>(
    {}
  );

  const ChangeShortcuts = () => {
    if (selectedshortcut) {
      //Busca mensagem
      getRequest(
        `companiesshortcuts/message?id=${String(
          selectedshortcut.value
        )}&TicketId=${String(selectTicketId)}`
      ).then(function (response) {
        handleInput(response.data);
        disableLoading();
      });
    }
  };

  useEffect(() => {
    async function getShortCuts() {
      await getRequest(
        `companiesshortcuts?CompanyId=${selectedCompany.id}`
      ).then(function (response) {
        const shortcuts = response.data;
        // console.log("shortcuts", shortcuts);
        setListShortcut(
          shortcuts.map(
            (shortcut: { id: string; title: string; active: boolean }) => ({
              value: shortcut.id,
              label: shortcut.title,
              active: shortcut.active,
            })
          )
        );
      });
    }

    getShortCuts();
  }, [selectedCompany.id]);

  return (
    <>
      <label className="title-combo-details-client-chat">
        {translate("shortcuts")}
      </label>
      <div className="form-row">
        <div className="form-group col-lg-8">
          <Select
            options={listshortcut.filter(
              (short: { active: boolean }) => short.active
            )}
            placeholder={`Selecione`}
            isMulti={false}
            isDisabled={blockTicket}
            getStyles="select2 form-control select2-multiple"
            value={selectedshortcut}
            onChange={(e: any) => setSelectedShortcut(e)}
          />
        </div>
        <button
          type="button"
          className="btn btn-outline-success"
          style={{ height: 38 }}
          onClick={ChangeShortcuts}
          disabled={blockTicket}
        >
          <i className=" uil-exchange"></i> {translate("confirm")}
        </button>
      </div>
    </>
  );
}
